module.exports = __webpack_public_path__ + "static/media/ryker-600.802d7475.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Selection/assets/ryker-600.png
// module id = 192
// module chunks = 0